import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Fridge = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 40"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <path
      fill={props.color || theme.palette.grey600}
      d="M8.333 26.667c0 .916-.75 1.666-1.666 1.666-.917 0-1.667-.75-1.667-1.666v-8.334H0V40h30V18.333H8.333v8.334zM26.667 0H3.333A3.335 3.335 0 000 3.333V15h5V6.667C5 5.75 5.75 5 6.667 5c.916 0 1.666.75 1.666 1.667V15H30V3.333A3.335 3.335 0 0026.667 0z"
    ></path>
  </svg>
);
